import React from "react";
import { images } from "../data/images";
import { ViewMode } from "../data/navigation";
type SiteHeroProps = {
  view: ViewMode;
};
export function SiteHero({
  view
}: SiteHeroProps) {
  return <div className="bg-white" data-id="element-212" data-mp="1ku5gt7jsqwcy">
      <div className="relative h-[560px] overflow-hidden" data-id="element-213" data-mp="1kv6w5o7ui50h">
        <img src={images.hero} alt="" className="absolute inset-0 h-full w-full object-cover object-[50%_35%]" data-id="element-214" data-mp="1ps71fwwvf3qj" />
        <div className="absolute inset-0 bg-i9-ink/35" aria-hidden="true" data-id="element-215" data-mp="2di1eofl3qubb" />
        <h2 className="absolute left-10 top-[42%] font-display text-6xl font-extrabold italic text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.35)]" data-id="element-216" data-mp="2hjmn9oqlsmfp">
          {view === "proposed" ? <>Why i9 Sports®</> : <>About i9 Sports®</>}
        </h2>
        <svg className="absolute bottom-0 left-0 h-28 w-full" viewBox="0 0 1200 120" preserveAspectRatio="none" aria-hidden="true" data-id="element-217" data-mp="s4yc1qtr1aj9">
          <polygon points="0,20 1200,95 1200,120 0,120" fill="#3cb4ef" data-id="element-218" data-mp="x4b5iuf4lfut" />
          <polygon points="0,48 1200,105 1200,120 0,120" fill="#e5302a" data-id="element-219" data-mp="1qyx330dnljov" />
          <polygon points="0,72 1200,112 1200,120 0,120" fill="#2a3fd6" data-id="element-220" data-mp="1r19ltfr8jy2z" />
        </svg>
      </div>
      <p className="flex items-center justify-center gap-4 py-10 font-display text-4xl font-bold uppercase text-i9-crimson" data-id="element-221" data-mp="1mzod86lqi5yl">
        <span className="text-i9-sky" aria-hidden="true" data-id="element-222" data-mp="1vyjf56hqwtw3">«</span>
        It's the way youth sports should be®
        <span className="text-i9-sky" aria-hidden="true" data-id="element-223" data-mp="29xj3ed1cj6rq">»</span>
      </p>
    </div>;
}